/* eslint-disable import/prefer-default-export */
import mitt from 'mitt';

export const competitionRegistrationEmitter = mitt();
export const kanbanUpdateColumnEmitter = mitt();
export const confirmDialogEmitter = mitt();
